export default __webpack_public_path__ + "static/media/TIER6.8f9e0a14.png";